import { createSlice } from "@reduxjs/toolkit";

const rawConfigSlice  = createSlice({
  name: "rawconfig",
  initialState: {
  rawconfigdata: {},
    loading: false
  },
  reducers: {
   setRawconfig: (state, action) => {
    console.log(action,"actiondatatssyudhdlkj")
  if (action.payload.rawconfig)
    state.rawconfigdata = action.payload.rawconfig;
 
},
   
  }
});

export const { setRawconfig } = rawConfigSlice.actions;
export default rawConfigSlice.reducer;
